/****************************************************
 * Module Name:  memoMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import * as React from "react";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Memo from "./memo";
import MemoIssue from "./memoIssue";
import MemoReturnManage from "./memoReturnManage";
// import MemoSell from './memoSell';
// import MemoSend from './memoSend';
// import MemoReceive from './memoReceive';
import Constants from "../../utility/constants";
import { BiNotepad } from "react-icons/bi";
import { GiGems } from "react-icons/gi";
import { GiTrade } from "react-icons/gi";
import NoPermission from "../common/noPermission";
//GiSellCard
// import { AiOutlineSend } from "react-icons/ai";
// import CallReceivedIcon from '@mui/icons-material/CallReceived';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 1 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
    value: index,
  };
}

export default function FullWidthTabs() {
  const theme = useTheme();
  const [value, setValue] = React.useState(
    true ? 0
      : Constants.USER_PERMISSION.find(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.OPERATION_MEMO_ISSUE
      ) !== undefined
        ? 1
        :
        true ? 2
          : Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_MEMO_SELL
          ) !== undefined
            ? 3
            : Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_MEMO_SEND
            ) !== undefined
              ? 4
              : Constants.USER_PERMISSION.find(
                (iPermission) =>
                  iPermission.permissionid ===
                  Constants.PERMISSIONS.OPERATION_MEMORECEIVE
              ) !== undefined
                ? 5
                : 6
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    value === 6 ? <NoPermission /> :
      <Box
        sx={{ bgcolor: "background.paper", width: "100%", padding: "10px" }}
      >
        <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
            variant="fullWidth"
            aria-label="full width tabs example"
            sx={{
              "& .css-1vw5i9y-MuiButtonBase-root-MuiTab-root": {
                color: "#212121",
                fontWeight: "bold",
                textAlign: 'center'
              },
              "& .MuiTab-root": {
                paddingBottom: 4
              },
              "& .Mui-selected": {
                bgcolor: "#0277bd !important",
                color: "#fafafa !important",
                fontWeight: "bold !important",
                paddingBottom: 4
              }
            }}
            TabIndicatorProps={{ style: { background: "#0277bd" } }}
          >

            <Tab
              icon={<BiNotepad fontSize={"large"} />}
              iconPosition="start"
              label="Memo"
              {...a11yProps(0)}
            />

            {Constants.USER_PERMISSION.find(
              (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_MEMO_ISSUE
            ) !== undefined
              ? (
                <Tab
                  icon={<GiGems fontSize={"large"} />}
                  iconPosition="start"
                  label="Issue"
                  {...a11yProps(1)}
                />
              ) : null}

            <Tab
              icon={<GiTrade fontSize={"large"} />}
              iconPosition="start"
              label="Manage"
              {...a11yProps(2)}
            />

            {/* {
              (Constants.USER_PERMISSION.find((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_MEMO_SELL) !== undefined) ? <Tab icon={<GiSellCard fontSize={'large'} />} iconPosition="start" label="Sell" {...a11yProps(3)} /> : null
            }
            {
              (Constants.USER_PERMISSION.find((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_MEMO_SEND) !== undefined) ? <Tab icon={<AiOutlineSend fontSize={'large'} />} iconPosition="start" label="Send" {...a11yProps(4)} /> : null
            }
            {
              (Constants.USER_PERMISSION.find((iPermission) => iPermission.permissionid === Constants.PERMISSIONS.OPERATION_MEMORECEIVE) !== undefined) ? <Tab icon={<CallReceivedIcon />} iconPosition="start" label="Receive" {...a11yProps(5)} /> : null
            } */}
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          onChangeIndex={handleChangeIndex}
        >

          <TabPanel value={value} index={0}>
            <Memo />
          </TabPanel>

          {Constants.USER_PERMISSION.find(
            (iPermission) =>
              iPermission.permissionid ===
              Constants.PERMISSIONS.OPERATION_MEMO_ISSUE
          ) !== undefined ? (
            <TabPanel value={value} index={1}>
              <MemoIssue />
            </TabPanel>
          ) : null}

          <TabPanel value={value} index={2}>
            <MemoReturnManage />
          </TabPanel>

        </SwipeableViews>
      </Box>
  );
}
